/**
 * @generated SignedSource<<331c00fd5f14367851894eed594ad843>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminPollFileListItem_IntegrationPollFile$data = {
  readonly file: {
    readonly name: string | null;
  } | null;
  readonly id: string;
  readonly url: string;
  readonly " $fragmentType": "IntegrationAdminPollFileListItem_IntegrationPollFile";
};
export type IntegrationAdminPollFileListItem_IntegrationPollFile$key = {
  readonly " $data"?: IntegrationAdminPollFileListItem_IntegrationPollFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminPollFileListItem_IntegrationPollFile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminPollFileListItem_IntegrationPollFile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IntegrationPollFile",
  "abstractKey": null
};

(node as any).hash = "9e76a14839825d24f8bc1fb627b8e1fa";

export default node;
